import {
  ADD_NOTE_TEMPLATES,
  ADD_NOTE_TEMPLATE,
  UPDATE_NOTE_TEMPLATE,
  REMOVE_NOTE_TEMPLATE,
  FETCHING_NOTE_TEMPLATES,
  FETCHED_NOTE_TEMPLATES,
  ADD_PROJECTS,
  CLEAR_ALL
} from "../actions/constants";
import defaults from "./defaults";

/**
 * Note-templates reducer.
 *
 * Shape:
 *   {
 *     list:     { [scope_key]: NoteTemplate[] },
 *     fetched:  { [scope_key]: Date },
 *     fetching: boolean,
 *     saving:   boolean
 *   }
 *
 * `scope_key` is `${account_id}:${project_id|'account'}` so project-scoped
 * and account-wide lookups live side-by-side without collision.
 *
 * Admin mutations land through ADD_NOTE_TEMPLATE / UPDATE_NOTE_TEMPLATE /
 * REMOVE_NOTE_TEMPLATE. Since a single admin action affects every scope that
 * includes that template, those actions walk every scope in `list` rather
 * than requiring the caller to know the scope_key.
 */
const noteTemplatesReducer = (state = defaults.noteTemplates, { type, payload }) => {
  switch (type) {
    case ADD_NOTE_TEMPLATES: {
      return {
        ...state,
        list: { ...state.list, [payload.scope_key]: payload.list }
      };
    }
    case ADD_NOTE_TEMPLATE: {
      const nextList = { ...state.list };
      for (const key of Object.keys(nextList)) {
        const existing = nextList[key] || [];
        if (!existing.some((t) => t.id === payload.id)) {
          nextList[key] = [...existing, payload];
        }
      }
      if (payload.scope_key && !nextList[payload.scope_key]) {
        nextList[payload.scope_key] = [payload];
      }
      return { ...state, list: nextList };
    }
    case UPDATE_NOTE_TEMPLATE: {
      const nextList = { ...state.list };
      for (const key of Object.keys(nextList)) {
        nextList[key] = (nextList[key] || []).map((t) =>
          t.id === payload.id ? { ...t, ...payload } : t
        );
      }
      return { ...state, list: nextList };
    }
    case REMOVE_NOTE_TEMPLATE: {
      const nextList = { ...state.list };
      for (const key of Object.keys(nextList)) {
        nextList[key] = (nextList[key] || []).filter((t) => t.id !== payload.id);
      }
      return { ...state, list: nextList };
    }
    case FETCHING_NOTE_TEMPLATES:
      return { ...state, fetching: payload };
    case FETCHED_NOTE_TEMPLATES:
      return {
        ...state,
        fetched: { ...state.fetched, [payload.scope_key]: new Date() }
      };
    case ADD_PROJECTS:
      return { ...state, list: {}, fetched: {}, fetching: false };
    case CLEAR_ALL:
      return defaults.noteTemplates;
    default:
      return state;
  }
};

export default noteTemplatesReducer;
